/**
 * NadLab single article — progress bar, share menus, citations accordion
 */
(function () {
  'use strict';

  function initProgressBar() {
    var bar = document.querySelector('.nadlab-progress__bar');
    if (!bar) return;

    function updateProgress() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      bar.style.width = Math.min(100, Math.max(0, progress)) + '%';
    }

    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  }

  function initShareMenus() {
    document.querySelectorAll('[data-nadlab-share-toggle]').forEach(function (toggle) {
      var menuId = toggle.getAttribute('aria-controls');
      var menu = menuId ? document.getElementById(menuId) : null;
      if (!menu) return;

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = menu.classList.contains('is-open');
        closeAllShareMenus();
        if (!isOpen) {
          menu.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', closeAllShareMenus);
  }

  function closeAllShareMenus() {
    document.querySelectorAll('.nadlab-rail__share-menu.is-open, .nadlab-share-dropdown__menu.is-open').forEach(function (menu) {
      menu.classList.remove('is-open');
    });
    document.querySelectorAll('[data-nadlab-share-toggle]').forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function initCitationsAccordion() {
    var toggle = document.querySelector('[data-nadlab-citations-toggle]');
    var panel = document.querySelector('[data-nadlab-citations-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      panel.classList.toggle('is-open', !expanded);
    });

    document.querySelectorAll('[data-nadlab-citations-jump]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        toggle.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-open');
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initCopyLink() {
    document.querySelectorAll('[data-nadlab-copy-link]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var url = btn.getAttribute('data-url') || window.location.href;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            var label = btn.textContent;
            btn.textContent = 'Link copied!';
            setTimeout(function () {
              btn.textContent = label;
            }, 2000);
          });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProgressBar();
    initShareMenus();
    initCitationsAccordion();
    initCopyLink();
  });
})();
